@if ({ type: type$ | async }; as data) {
  <div
    class="root"
    data-test="прикрепленный файл"
    [class.-wide]="data.type === AttachmentFileType.other || data.type === AttachmentFileType.video"
    [class.-big]="bigAttachmentPreview"
  >
    <div
      class="preview"
      [style.backgroundImage]="data.type === AttachmentFileType.image ? 'url(' + url + ')' : 'none'"
      (click)="openFullsizeMedia()"
      [title]="title"
    >
      @if (data.type === AttachmentFileType.video) {
        <div class="icon">
          <svg
            class="type-icon"
            viewBox="64 64 896 896"
            focusable="false"
            fill="currentColor"
            width="1em"
            height="1em"
            data-icon="play-circle"
            aria-hidden="true"
          >
            <path
              d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
              fill="#565eef"
            ></path>
            <path
              d="M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 01-12.7-6.5V353a8 8 0 0112.7-6.5l218.4 158.8a7.9 7.9 0 010 12.9z"
              fill="#edecff"
            ></path>
            <path
              d="M676.1 505.3L457.7 346.5A8 8 0 00445 353v317.6a8.02 8.02 0 0012.7 6.5l218.4-158.9a7.9 7.9 0 000-12.9z"
              fill="#565eef"
            ></path>
          </svg>
          <div class="file-name">
            {{ title }}
          </div>
        </div>
      }
      @if (data.type === AttachmentFileType.other) {
        <div class="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="type-icon"
            viewBox="0 0 22 22"
            focusable="false"
            fill="currentColor"
            width="1em"
            height="1em"
            data-icon="file"
            aria-hidden="true"
          >
            <path
              d="M19.4121 5.51473L14.1282 0.230804C13.9808 0.0834822 13.782 0 13.5732 0H3.14289C2.70829 0 2.35718 0.351116 2.35718 0.785714V21.2143C2.35718 21.6489 2.70829 22 3.14289 22H18.8572C19.2918 22 19.6429 21.6489 19.6429 21.2143V6.0721C19.6429 5.86339 19.5594 5.66205 19.4121 5.51473ZM13.2099 1.81205L17.8308 6.43304H13.2099V1.81205ZM17.875 20.2321H4.12503V1.76786H11.5402V7.07143C11.5402 7.34493 11.6489 7.60724 11.8423 7.80063C12.0357 7.99403 12.298 8.10268 12.5715 8.10268H17.875V20.2321Z"
              fill="#565EEF"
            />
          </svg>
          <div class="file-name">
            {{ title }}
          </div>
        </div>
      }
      <ng-content></ng-content>
    </div>
  </div>
}
